/* eslint-disable quote-props */
import api from "./api"

export default {
  get: async (url:string, token: string) => {
    const actualURL = `${api[api.env].backendURL}/${url}`
    try {
      const requestData = {
        method: "GET",
        url: actualURL,
        token,
      }

      const Response = await fetch(actualURL, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
          Authorization: `Bearer ${token}`,
          Source: "EASYFIX",
          IsNonOwner: "N",
        },
      })

      const data = await Response.json()

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },

  post: async (url: string, body: any, token: string, headers:any) => {
    // const actualURL = `${api[api.env].backendURL}/${url}`
    try {
      const requestData = {
        method: "POST",
        url,
        body,
        token,
      }

      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: headers || {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
          Authorization: `Bearer ${token}`,
          Source: "EASYFIX",
          IsNonOwner: "N",
          "x-bpid": "hdashd",
        },
      })

      let data
      if ((url = `${api[api.env].backendURL}/getServiceDetails`)) {
        if (Response.status != 200) {
          data = { Status: { Code: Response.status, Type: "NOK" } }
        } else {
          data = await Response.json()
        }
      } else {
        data = await Response.json()
      }

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },

  getTass: async (url: string, body: any, token: string, randomString: string) => {
    try {
      const requestData = {
        method: "GET",
        url: url,
        token,
      }

      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
      })

      const data = await Response.json()

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },
  postTass: async (url: string, body: any, token: string, randomString: string) => {
    try {
      const requestData = {
        method: "POST",
        url: url,
        token,
      }

      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
      })

      const data = await Response.json()

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },
  postToken: async (url: string, body: any, token: string, headers:any) => {
    // const actualURL = `${api[api.env].backendURL}/${url}`
    try {
      const requestData = {
        method: "POST",
        url,
        body,
        token,
      }


      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: `Basic ${token}`, 
        },
      })

      let data
      if ((url = `${api[api.env].backendURL}/getServiceDetails`)) {
        if (Response.status != 200) {
          data = { Status: { Code: Response.status, Type: "NOK" } }
        } else {
          data = await Response.json()
        }
      } else {
        data = await Response.json()
      }

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },
  getAppo: async (url: string, body: any, token: string, randomString: string) => {
    try {
      const requestData = {
        method: "POST",
        url: url,
        token,
      }

      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
      })

      const data = await Response.json()

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },
  setAppo: async (url: string, body: any, token: string, randomString: string) => {
    try {
      const requestData = {
        method: "POST",
        url: url,
        token,
      }

      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
      })

      const data = await Response.json()

      return data
    } catch (error) {
      console.log("%c API Error", "font-weight: bold; color: #F54242", error)
    }
  },

  postIWS: async (url: string, body: any, token: string, randomString: string) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 10s timeout
  
    try {
      const Response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
        signal: controller.signal, // attach abort signal
      });
  
      clearTimeout(timeoutId);
  
      let data;
      if (Response.status !== 200) {
        data = { Status: { Code: Response.status, Type: "NOK" } };
      } else {
        data = await Response.json();
      }
  
      return data;
    } catch (error: unknown) {
      clearTimeout(timeoutId);
  
      if (error instanceof DOMException && error.name === "AbortError") {
        return {
          success: false,
          error: "Request timed out. Please try again.",
        };
      }
  
      if (error instanceof TypeError && error.message === "Failed to fetch") {
        return {
          success: false,
          error: "Network error - please check your internet connection.",
        };
      }
  
      if (error instanceof Error) {
        return {
          success: false,
          error: error.message,
        };
      }
  
      return {
        success: false,
        error: "An unknown error occurred",
      };
    }
  },
  postIWSStatus: async (url: string, body: any, token: string, randomString: string) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        body: body,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "x-calling-application": "MyUnifi",
          LightWeightFlag: "YES",
          Authorization: `Bearer ${token}`,
          "x-cacheflag": "YES",
          "x-bpid": randomString,
          "X-Gravitee-Api-Key": `${api[api.env].apiKey}`,
        },
      });
  
      const status = response.status; // ✅ Capture HTTP status
      const json = await response.json().catch(() => ({}));

    // ✅ Flatten response: if `json.data` contains `data`, return only the inner one
    const data =
      json?.data && Array.isArray(json.data.data)
        ? json.data.data
        : json?.data || json;
  
      return { status, data }; // ✅ Return both
    } catch (error) {
      console.error("%c API Error", "font-weight: bold; color: #F54242", error);
      // ✅ Always return consistent shape even on error
      return { status: 500, data: { message: "Network or unknown error" } };
    }
  },
}
